import { useContext, useRef } from "react"
import axios from "axios"

import { UserContext } from "../../../context/userContext"

import auditLogApi from "../../../config/auditLogApi"

function getTemplateId(url) {
  const parts = url.split("/form/view/")
  if (parts.length > 1) {
    return parts[1].split("/")[0] // Extracts the first part after '/form/view/'
  }
  return null
}

function AuditRoute(props) {
  const hasAudited = useRef(false)
  const userCtx = useContext(UserContext)

  if (!props.audit) return props.children

  const user = userCtx.session.user

  const handleAuditId = () => {
    const idMap = {
      participant: userCtx.current_participant_id,
      staff: userCtx.current_staff_membership_id,
      organization: userCtx.current_organization_id,
    }

    if (idMap[props.auditType]) {
      return idMap[props.auditType]
    }

    if (props.auditType === "dynamic") {
      const currentTemplate = getTemplateId(window.location.pathname)
      const templateDef =
        props.auditTemplateList.find((item) => item[0] === currentTemplate) ||
        []
      const templateType = templateDef[1] || ""

      return idMap[templateType]
    }

    // Default case
    return user.staff_id
  }

  const handleAuditType = () => {
    if (props.auditType === "dynamic") {
      const currentTemplate = getTemplateId(window.location.pathname)
      const templateDef =
        props.auditTemplateList.find((item) => item[0] === currentTemplate) ||
        []
      return templateDef[1] || ""
    }
    return props.auditType
  }

  const isFormView = window.location.pathname.includes("/form/view/")

  if (isFormView) {
    const currentTemplate = getTemplateId(window.location.pathname)
    const templateIdList = props.auditTemplateList.map(
      (template) => template[0]
    )

    // Check if the current template is in the list of templates to audit
    if (!templateIdList.includes(currentTemplate)) {
      return props.children
    }
  }

  if (!hasAudited.current) {
    try {
      const getAuditLogApiUrl = auditLogApi()
      const apiUrl = `${getAuditLogApiUrl}client-app`
      const options = {
        data: {
          audit_type: handleAuditType(),
          audit_id: handleAuditId(),
          audit_record_id: user.staff_id,
          audit_record_type: window.location.pathname,
          audit_record_url: window.location.href,
          audit_record_user_id: user.staff_id,
          audit_record_username:
            user.staff_name_first + " " + user.staff_name_last,
          date_changed: new Date().toISOString(),
          enterprise_id: user.enterprise_id,
          organization_id: user.organization_id,
        },
        headers: {
          Authorization: `Bearer ${userCtx.token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        url: apiUrl,
        withCredentials: true,
      }
      axios.request(options)
    } catch (error) {
      console.log("Error submitting to Audit Log service.", error)
    } finally {
      hasAudited.current = true
    }
  }

  return props.children
}

export default AuditRoute
